<template>
  <Card style="min-width:350px">
    <div slot="title" style="text-transform: capitalize;display: flex">
      <div style="padding-right: 2em;">
        <h5>
          <i :class="'fa fa-sign-' + locationIcon" aria-hidden="true"></i>
          {{ location.title }}
        </h5>
      </div>
      <div>
        <h5
          style="font-weight: 400"
          v-for="time in location.times"
          :key="time.index"
        >
          {{ time.prefix }} {{ time.dateTime }}
        </h5>
      </div>
    </div>
    <h3>{{ location.name }}</h3>
    <div v-if="showDetails">
      <p>
        {{ location.address.street_number }} {{ location.address.street_name }}
      </p>
      <p>{{ location.address.suburb }}</p>
      <p>{{ location.address.city }}</p>
      <h5>{{ location.address.region }}</h5>
      <hr v-if="location.ref" />
      <p v-if="location.ref"><b>Reference</b> {{ location.ref }}</p>
    </div>
    <div v-else>
      <a href="#!" @click="showDetails = true">More details ></a>
    </div>
  </Card>
</template>

<script>
export default {
  name: "Location",
  props: {
    location: {
      type: Object,
      required: true
    },
    locationIcon: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showDetails: false
    };
  }
};
</script>

<style scoped>
p {
  margin-bottom: 0.5rem;
}
</style>
